export default __webpack_public_path__ + "static/vietnamHeader-a810c483fe10a3d75dcbc65c990fe5c1.jpg";